// i18n dictionaries for Montessori24 — FI default, plus EN, SV, ET.
// Add new keys to the `fi` object first (it's the source of truth);
// missing keys in other languages fall back to Finnish at runtime.

export const fi = {
  // Top banner
  "banner.discount": "−10 % ensitilauksesta koodilla",
  "banner.discountCode": "TERVETULOA10",
  "banner.shipping": "Ilmainen toimitus Suomeen · Varastotuotteet lähtevät 1–2 arkipäivässä",

  // Navigation
  "nav.shop": "Kauppa",
  "nav.age": "Ikä",
  "nav.school": "Montessori-koulu",
  "nav.history": "Historia",
  "nav.education": "Koulutus",
  "nav.about": "Meistä",
  "nav.faq": "UKK",
  "nav.openMenu": "Avaa valikko",
  "nav.climbing": "Kiipeily",
  "nav.learning": "Oppiminen",
  "nav.kidsroom": "Lastenhuone",
  "nav.guide": "Montessori-opas",
  "nav.new": "Uutuudet",
  "nav.toys": "Montessori Lelut",
  "nav.gift": "Lahjaksi",
  "nav.byAge": "Iän mukaan",
  "nav.all": "Selaa koko mallistoa",
  "nav.account": "Oma tili",
  "nav.guides": "Oppaat & artikkelit",
  "mega.headline": "Pienet hetket. Suuri kasvu.",
  "mega.cta": "Tutustu mallistoon",

  // Age subnav
  "age.0-1": "0–1 v",
  "age.1-3": "1–3 v",
  "age.3-6": "3–6 v",

  // Shop subnav
  "shop.climbing": "Kiipeilytelineet",
  "shop.tower": "Oppimistornit",
  "shop.table": "Pöydät & tuolit",
  "shop.storage": "Säilytys",
  "shop.iglu": "IGLU Blocks",
  "shop.guides": "Oppaat",
  "shop.towerGuide": "Oppimistorni-opas",
  "shop.school": "Montessori-koulu",


  // Sticky CTA
  "cta.buyNow": "Osta nyt — ilmainen toimitus →",

  // Cart
  "cart.title": "Ostoskori",
  "cart.empty": "Korisi on tyhjä",
  "cart.items": "{count} tuotetta korissa",
  "cart.item": "{count} tuote korissa",
  "cart.shippingIncluded": "✓ Ilmainen toimitus sisältyy tilaukseesi",
  "cart.total": "Yhteensä",
  "cart.checkout": "Siirry kassalle",
  "cart.aria": "Ostoskori",
  "cart.paymentMethods": "Turvallinen maksu · Klarna · MobilePay · Visa · Mastercard · Apple Pay",

  // Product cards
  "product.addToCart": "Lisää koriin",
  "product.soldOut": "Loppu",
  "products.eyebrow": "Mallisto",
  "products.title": "Suositellut tuotteet",
  "products.subtitle": "Huolella valittuja eurooppalaisia Pikler-kiipeilytelineitä, oppimistorneja ja Montessori-kalusteita — ilmainen toimitus Suomeen 3–7 arkipäivässä.",
  "products.viewAll": "Katso koko mallisto →",
  "products.empty": "Mallistoa päivitetään. Palaa pian tai ota yhteyttä asiakaspalveluun.",

  // Footer
  "footer.tagline": "Kasvua omassa tahdissa. Suomalainen Montessori-verkkokauppa, joka kokoaa yhteen huolella valittuja eurooppalaisia lasten tuotteita.",
  "footer.shop": "Kauppa",
  "footer.support": "Tuki ja oppiminen",
  "footer.legal": "Lakisääteinen",
  "footer.contact": "Yhteystiedot",
  "footer.shipping": "Toimitus",
  "footer.returns": "Palautukset",
  "footer.terms": "Käyttöehdot",
  "footer.privacy": "Tietosuojaseloste",
  "footer.cookies": "Evästekäytäntö",
  "footer.withdrawal": "Peruutusoikeus (14 pv)",
  "footer.privacyShort": "Tietosuoja",
  "footer.cookiesShort": "Evästeet",
  "footer.businessId": "Y-tunnus",
  "footer.location": "Helsinki, Suomi",
  "footer.copyright": "© {year} Montessori24. Kaikki oikeudet pidätetään.",
  "footer.vat": "· Hinnat sis. ALV 25,5 %",

  // Footer — product link labels
  "footer.link.pikler": "Pikler-kiipeilyteline",
  "footer.link.tower": "Oppimistorni",
  "footer.link.bed": "Montessori-sänky",
  "footer.link.clothes": "Vaaterekki",
  "footer.link.toys": "Montessori-lelut",
  "footer.shopAll": "Kauppa — kaikki",

  // Footer — customer service hours
  "footer.hoursHeader": "Ilmainen Montessori-koulu",
  "footer.hoursTime": "Artikkeleita, ikäoppaita ja turvallisuusvinkkejä vanhemmalle.",

  // Footer — trust strip
  "footer.trust.paymentsHeader": "Maksutavat",
  "footer.trust.paymentsNote": "Maksuliikenne salataan SSL-tekniikalla. Turvallinen maksunvälitys.",
  "footer.trust.banktransfer": "Verkkopankit",
  "footer.trust.consumerHeader": "Kuluttajansuoja",
  "footer.trust.promisesHeader": "Lupauksemme",
  "footer.trust.promiseShipping": "Ilmainen toimitus 3–7 arkipäivässä",
  "footer.trust.promiseReturns": "30 päivän palautusetu · 14 pv lakisääteinen",
  "footer.trust.promiseCE": "Tuotekohtaiset turvallisuustiedot",
  "footer.trust.promiseFinnish": "Suomalainen verkkokauppa · eurooppalaiset valmistajat",

  // Language switcher
  "lang.label": "Kieli",
  "lang.fi": "Suomi",
  "lang.en": "English",
  "lang.sv": "Svenska",
  "lang.et": "Eesti",

  // Shipping / market messaging (US market overrides in `enUS`)
  "ship.cartTagline": "Ilmainen toimitus 3–7 pv",
  "ship.cartVatNote": "sis. ALV",
  "ship.cartSecure": "Turvallinen maksu",

  // Translation notice (shown on long-form pages)
  "notice.translating": "Tämän sivun sisältöä käännetään parhaillaan. Tärkein tieto näkyy, ja koko sivu on saatavilla suomeksi.",
  "notice.switchToFi": "Vaihda suomeksi",

  // Cookie consent banner
  "consent.title": "Käytämme evästeitä",
  "consent.body": "Käytämme välttämättömiä evästeitä sivuston toimintaan sekä valinnaisia analytiikka- ja markkinointievästeitä kokemuksen parantamiseksi. Voit hyväksyä kaikki, hylätä valinnaiset tai valita itse.",
  "consent.readMore": "Lue evästekäytäntö",
  "consent.acceptAll": "Hyväksy kaikki",
  "consent.rejectAll": "Hylkää valinnaiset",
  "consent.customize": "Mukauta",
  "consent.save": "Tallenna valinnat",
  "consent.back": "Takaisin",
  "consent.necessary": "Välttämättömät",
  "consent.necessaryDesc": "Aina käytössä. Tarvitaan sivuston perustoimintoihin, kuten ostoskoriin ja kirjautumiseen.",
  "consent.analytics": "Analytiikka",
  "consent.analyticsDesc": "Auttavat ymmärtämään, miten sivustoa käytetään, jotta voimme kehittää sitä.",
  "consent.marketing": "Markkinointi",
  "consent.marketingDesc": "Käytetään mahdollisesti kohdennettuun mainontaan ja kampanjoiden mittaamiseen.",
  "consent.manage": "Evästeasetukset",
} as const;

export type DictKey = keyof typeof fi;
type PartialDict = Partial<Record<DictKey, string>>;

export const en: PartialDict = {
  "banner.discount": "−10% off your first order with code",
  "banner.discountCode": "TERVETULOA10",
  "banner.shipping": "Free shipping · In-stock items dispatched within 1–2 business days",

  "nav.shop": "Shop",
  "nav.age": "Age",
  "nav.school": "Montessori school",
  "nav.about": "About",
  "nav.faq": "FAQ",
  "nav.openMenu": "Open menu",
  "nav.climbing": "Climbing",
  "nav.learning": "Learning",
  "nav.kidsroom": "Kids' room",
  "nav.guide": "Montessori guide",
  "nav.new": "New arrivals",
  "nav.toys": "Montessori Toys",
  "nav.gift": "As a gift",
  "nav.byAge": "Shop by age",
  "nav.all": "Browse the whole collection",
  "nav.account": "My account",
  "nav.guides": "Guides & articles",
  "mega.headline": "Small moments. Big growth.",
  "mega.cta": "Explore the collection",

  "age.0-1": "0–1 y",
  "age.1-3": "1–3 y",
  "age.3-6": "3–6 y",

  "shop.climbing": "Climbing frames",
  "shop.tower": "Learning towers",
  "shop.table": "Tables & chairs",
  "shop.storage": "Storage",
  "shop.iglu": "IGLU Blocks",
  "shop.guides": "Guides",
  "shop.towerGuide": "Learning tower guide",
  "shop.school": "Montessori school",


  "cta.buyNow": "Shop now — free shipping →",

  "cart.title": "Cart",
  "cart.empty": "Your cart is empty",
  "cart.items": "{count} items in cart",
  "cart.item": "{count} item in cart",
  "cart.shippingIncluded": "✓ Free shipping included",
  "cart.total": "Total",
  "cart.checkout": "Go to checkout",
  "cart.aria": "Cart",
  "cart.paymentMethods": "Secure payment · Klarna · MobilePay · Visa · Mastercard · Apple Pay",

  "product.addToCart": "Add to cart",
  "product.soldOut": "Sold out",
  "products.eyebrow": "Collection",
  "products.title": "Featured products",
  "products.subtitle": "Carefully selected European Pikler climbing frames, learning towers and Montessori furniture — free shipping across Europe in 3–7 business days.",
  "products.viewAll": "See the full collection →",
  "products.empty": "The collection is being refreshed. Please check back soon or contact customer service.",

  "footer.tagline": "Growing at their own pace. A Finnish Montessori store bringing together carefully selected European products for children.",
  "footer.shop": "Shop",
  "footer.support": "Support & learning",
  "footer.legal": "Legal",
  "footer.contact": "Contact",
  "footer.shipping": "Shipping",
  "footer.returns": "Returns",
  "footer.terms": "Terms of service",
  "footer.privacy": "Privacy policy",
  "footer.cookies": "Cookie policy",
  "footer.withdrawal": "Right of withdrawal (14 days)",
  "footer.privacyShort": "Privacy",
  "footer.cookiesShort": "Cookies",
  "footer.businessId": "Business ID",
  "footer.location": "Helsinki, Finland",
  "footer.copyright": "© {year} Montessori24. All rights reserved.",
  "footer.vat": "· Prices incl. 25.5% VAT",

  "footer.link.pikler": "Pikler climbing frame",
  "footer.link.tower": "Learning tower",
  "footer.link.bed": "Montessori bed",
  "footer.link.clothes": "Kids' clothing rack",
  "footer.link.toys": "Montessori toys",
  "footer.shopAll": "Shop — all",

  "footer.hoursHeader": "Free Montessori school",
  "footer.hoursTime": "Articles, age guides and safety tips for parents.",

  "footer.trust.paymentsHeader": "Payment methods",
  "footer.trust.paymentsNote": "Payments are SSL-encrypted. Secure processing.",
  "footer.trust.banktransfer": "Bank transfer",
  "footer.trust.consumerHeader": "Consumer protection",
  "footer.trust.promisesHeader": "Our promise",
  "footer.trust.promiseShipping": "Free shipping in 3–7 business days",
  "footer.trust.promiseReturns": "30-day returns · 14-day statutory right",
  "footer.trust.promiseCE": "Product-specific safety information",
  "footer.trust.promiseFinnish": "Finnish store · European makers",

  "lang.label": "Language",
  "lang.fi": "Suomi",
  "lang.en": "English",
  "lang.sv": "Svenska",
  "lang.et": "Eesti",

  "notice.translating": "This page is being translated. Key info is available, and the full page is in Finnish.",
  "notice.switchToFi": "Switch to Finnish",

  "consent.title": "We use cookies",
  "consent.body": "We use necessary cookies to run the site and optional analytics and marketing cookies to improve your experience. You can accept all, reject optional cookies, or choose yourself.",
  "consent.readMore": "Read cookie policy",
  "consent.acceptAll": "Accept all",
  "consent.rejectAll": "Reject optional",
  "consent.customize": "Customize",
  "consent.save": "Save preferences",
  "consent.back": "Back",
  "consent.necessary": "Necessary",
  "consent.necessaryDesc": "Always on. Required for core site functions like cart and login.",
  "consent.analytics": "Analytics",
  "consent.analyticsDesc": "Help us understand how the site is used so we can improve it.",
  "consent.marketing": "Marketing",
  "consent.marketingDesc": "Used for potentially targeted advertising and campaign measurement.",
  "consent.manage": "Cookie settings",
};

export const sv: PartialDict = {
  "banner.discount": "−10 % på din första beställning med koden",
  "banner.discountCode": "TERVETULOA10",
  "banner.shipping": "Fri frakt · Varor i lager skickas inom 1–2 arbetsdagar",

  "nav.shop": "Butik",
  "nav.age": "Ålder",
  "nav.school": "Montessori-skolan",
  "nav.about": "Om oss",
  "nav.faq": "Vanliga frågor",
  "nav.openMenu": "Öppna meny",
  "nav.climbing": "Klättring",
  "nav.learning": "Lärande",
  "nav.kidsroom": "Barnrummet",
  "nav.guide": "Montessori-guiden",
  "nav.new": "Nyheter",
  "nav.toys": "Montessori-leksaker",
  "nav.gift": "Att ge bort",
  "nav.byAge": "Handla efter ålder",
  "nav.all": "Se hela kollektionen",
  "nav.account": "Mitt konto",
  "nav.guides": "Guider & artiklar",
  "mega.headline": "Små ögonblick. Stor utveckling.",
  "mega.cta": "Utforska kollektionen",

  "age.0-1": "0–1 år",
  "age.1-3": "1–3 år",
  "age.3-6": "3–6 år",

  "shop.climbing": "Klätterställningar",
  "shop.tower": "Lärtorn",
  "shop.table": "Bord & stolar",
  "shop.storage": "Förvaring",
  "shop.iglu": "IGLU Blocks",
  "shop.guides": "Guider",
  "shop.towerGuide": "Guide till lärtornet",
  "shop.school": "Montessori-skolan",

  "cta.buyNow": "Handla nu — fri frakt →",


  "cart.title": "Varukorg",
  "cart.empty": "Din varukorg är tom",
  "cart.items": "{count} varor i varukorgen",
  "cart.item": "{count} vara i varukorgen",
  "cart.shippingIncluded": "✓ Fri frakt ingår",
  "cart.total": "Totalt",
  "cart.checkout": "Till kassan",
  "cart.aria": "Varukorg",
  "cart.paymentMethods": "Säker betalning · Klarna · MobilePay · Visa · Mastercard · Apple Pay",

  "product.addToCart": "Lägg i varukorg",
  "product.soldOut": "Slut",
  "products.eyebrow": "Kollektion",
  "products.title": "Utvalda produkter",
  "products.subtitle": "Noggrant utvalda europeiska Pikler-klätterställningar, lärtorn och Montessori-möbler — fri frakt inom Finland på 3–7 arbetsdagar.",
  "products.viewAll": "Se hela kollektionen →",
  "products.empty": "Kollektionen uppdateras. Titta in igen snart eller kontakta kundtjänst.",

  "footer.tagline": "Växer i sin egen takt. En finländsk Montessori-butik med noggrant utvalda europeiska barnprodukter.",
  "footer.shop": "Butik",
  "footer.support": "Support & lärande",
  "footer.legal": "Juridiskt",
  "footer.contact": "Kontakt",
  "footer.shipping": "Leverans",
  "footer.returns": "Returer",
  "footer.terms": "Användarvillkor",
  "footer.privacy": "Integritetspolicy",
  "footer.cookies": "Cookiepolicy",
  "footer.withdrawal": "Ångerrätt (14 dagar)",
  "footer.privacyShort": "Integritet",
  "footer.cookiesShort": "Cookies",
  "footer.businessId": "FO-nummer",
  "footer.location": "Helsingfors, Finland",
  "footer.copyright": "© {year} Montessori24. Alla rättigheter förbehållna.",
  "footer.vat": "· Priser inkl. moms 25,5 %",

  "footer.link.pikler": "Pikler-klätterställning",
  "footer.link.tower": "Lärtorn",
  "footer.link.bed": "Montessori-säng",
  "footer.link.clothes": "Barnens klädhängare",
  "footer.link.toys": "Montessori-leksaker",
  "footer.shopAll": "Butik — allt",

  "footer.hoursHeader": "Gratis Montessori-skola",
  "footer.hoursTime": "Artiklar, åldersguider och säkerhetstips för föräldrar.",

  "footer.trust.paymentsHeader": "Betalsätt",
  "footer.trust.paymentsNote": "Alla betalningar är SSL-krypterade. Säker betalningsförmedling.",
  "footer.trust.banktransfer": "Nätbanker",
  "footer.trust.consumerHeader": "Konsumentskydd",
  "footer.trust.promisesHeader": "Våra löften",
  "footer.trust.promiseShipping": "Fri frakt på 3–7 arbetsdagar",
  "footer.trust.promiseReturns": "30 dagars returrätt · 14 dagars lagstadgad ångerrätt",
  "footer.trust.promiseCE": "Produktspecifik säkerhetsinformation",
  "footer.trust.promiseFinnish": "Finländsk butik · europeiska tillverkare",

  "ship.cartTagline": "Fri frakt 3–7 dagar",
  "ship.cartVatNote": "inkl. moms",
  "ship.cartSecure": "Säker betalning",

  "lang.label": "Språk",
  "lang.fi": "Suomi",
  "lang.en": "English",
  "lang.sv": "Svenska",
  "lang.et": "Eesti",

  "notice.translating": "Den här sidan översätts. Viktig information visas; hela sidan finns på finska.",
  "notice.switchToFi": "Byt till finska",

  "consent.title": "Vi använder cookies",
  "consent.body": "Vi använder nödvändiga cookies för att driva webbplatsen och valfria analys- och marknadsföringscookies för att förbättra din upplevelse. Du kan acceptera alla, avvisa valfria eller välja själv.",
  "consent.readMore": "Läs cookiepolicy",
  "consent.acceptAll": "Acceptera alla",
  "consent.rejectAll": "Avvisa valfria",
  "consent.customize": "Anpassa",
  "consent.save": "Spara val",
  "consent.back": "Tillbaka",
  "consent.necessary": "Nödvändiga",
  "consent.necessaryDesc": "Alltid på. Krävs för webbplatsens grundfunktioner som kundvagn och inloggning.",
  "consent.analytics": "Analys",
  "consent.analyticsDesc": "Hjälper oss förstå hur webbplatsen används så att vi kan förbättra den.",
  "consent.marketing": "Marknadsföring",
  "consent.marketingDesc": "Används för eventuellt riktad annonsering och kampanjmätning.",
  "consent.manage": "Cookieinställningar",
};

export const et: PartialDict = {
  "banner.discount": "−10 % esimeselt tellimuselt koodiga",
  "banner.discountCode": "TERVETULOA10",
  "banner.shipping": "Tasuta tarne · Laos olevad tooted saadame 1–2 tööpäeva jooksul",

  "nav.shop": "Pood",
  "nav.age": "Vanus",
  "nav.school": "Montessori-kool",
  "nav.about": "Meist",
  "nav.faq": "KKK",
  "nav.openMenu": "Ava menüü",
  "nav.climbing": "Ronimine",
  "nav.learning": "Õppimine",
  "nav.kidsroom": "Lasteruum",
  "nav.guide": "Montessori juhend",
  "nav.new": "Uudsed tooted",
  "nav.toys": "Montessori mänguasjad",
  "nav.gift": "Kingituseks",
  "nav.byAge": "Vanuse järgi",
  "nav.all": "Sirvi kogu kollektsiooni",
  "nav.account": "Minu konto",
  "nav.guides": "Juhendid ja artiklid",
  "mega.headline": "Väikesed hetked. Suur kasv.",
  "mega.cta": "Tutvu kollektsiooniga",

  "age.0-1": "0–1 a",
  "age.1-3": "1–3 a",
  "age.3-6": "3–6 a",

  "shop.climbing": "Ronimisraamid",
  "shop.tower": "Õppimistornid",
  "shop.table": "Lauad ja toolid",
  "shop.storage": "Hoiustamine",
  "shop.iglu": "IGLU Blocks",
  "shop.guides": "Juhendid",
  "shop.towerGuide": "Õppimistorni juhend",
  "shop.school": "Montessori-kool",

  "cta.buyNow": "Osta kohe — tasuta tarne →",


  "cart.title": "Ostukorv",
  "cart.empty": "Ostukorv on tühi",
  "cart.items": "{count} toodet ostukorvis",
  "cart.item": "{count} toode ostukorvis",
  "cart.shippingIncluded": "✓ Tasuta tarne sisaldub",
  "cart.total": "Kokku",
  "cart.checkout": "Mine kassasse",
  "cart.aria": "Ostukorv",
  "cart.paymentMethods": "Turvaline makse · Klarna · MobilePay · Visa · Mastercard · Apple Pay",

  "product.addToCart": "Lisa korvi",
  "product.soldOut": "Otsas",
  "products.eyebrow": "Kollektsioon",
  "products.title": "Soovitatud tooted",
  "products.subtitle": "Hoolikalt valitud Euroopa Pikler-ronimisraamid, õppimistornid ja Montessori-mööbel — tasuta tarne Euroopas 3–7 tööpäevaga.",
  "products.viewAll": "Vaata kogu kollektsiooni →",
  "products.empty": "Kollektsiooni uuendatakse. Vaata peagi uuesti või võta ühendust klienditoega.",

  "footer.tagline": "Kasvamine omas tempos. Soome Montessori-veebipood, mis koondab hoolikalt valitud Euroopa lastetooteid.",
  "footer.shop": "Pood",
  "footer.support": "Tugi ja õppimine",
  "footer.legal": "Juriidiline",
  "footer.contact": "Kontakt",
  "footer.shipping": "Tarne",
  "footer.returns": "Tagastused",
  "footer.terms": "Kasutustingimused",
  "footer.privacy": "Privaatsuspoliitika",
  "footer.cookies": "Küpsiste poliitika",
  "footer.withdrawal": "Taganemisõigus (14 päeva)",
  "footer.privacyShort": "Privaatsus",
  "footer.cookiesShort": "Küpsised",
  "footer.businessId": "Registrikood",
  "footer.location": "Helsingi, Soome",
  "footer.copyright": "© {year} Montessori24. Kõik õigused kaitstud.",
  "footer.vat": "· Hinnad sis. käibemaks 25,5 %",

  "lang.label": "Keel",
  "lang.fi": "Suomi",
  "lang.en": "English",
  "lang.sv": "Svenska",
  "lang.et": "Eesti",

  "notice.translating": "Selle lehe tõlge on töös. Põhiteave on saadaval; täielik leht on soome keeles.",
  "notice.switchToFi": "Vaheta soome keelele",

  "footer.hoursHeader": "Tasuta Montessori-kool",
  "footer.hoursTime": "Artiklid, vanusejuhised ja ohutusnõuanded lapsevanematele.",

  "consent.title": "Kasutame küpsiseid",
  "consent.body": "Kasutame vajalikke küpsiseid saidi toimimiseks ning valikulisi analüütika- ja turundusküpsiseid kasutuskogemuse parandamiseks. Võid nõustuda kõigiga, keelduda valikulistest või valida ise.",
  "consent.readMore": "Loe küpsiste poliitikat",
  "consent.acceptAll": "Nõustu kõigiga",
  "consent.rejectAll": "Keeldu valikulistest",
  "consent.customize": "Kohanda",
  "consent.save": "Salvesta valikud",
  "consent.back": "Tagasi",
  "consent.necessary": "Vajalikud",
  "consent.necessaryDesc": "Alati sees. Vajalikud saidi põhitoiminguteks nagu ostukorv ja sisselogimine.",
  "consent.analytics": "Analüütika",
  "consent.analyticsDesc": "Aitavad mõista, kuidas saiti kasutatakse, et saaksime seda parandada.",
  "consent.marketing": "Turundus",
  "consent.marketingDesc": "Kasutatakse võimalikuks sihitud reklaamiks ja kampaaniate mõõtmiseks.",
  "consent.manage": "Küpsiste seaded",
};

/**
 * English for the US market. Currency, tax and shipping copy differ from
 * the EU-facing English strings (no VAT included in price, USD, US delivery
 * window, US-facing payment methods).
 */
export const enUS: PartialDict = {
  ...en,
  "banner.discount": "10% off your first order with code",
  "banner.shipping": "Free US shipping · 6–10 business days",

  "cta.buyNow": "Shop now — free US shipping →",

  "cart.shippingIncluded": "✓ Free shipping to the US included",
  "cart.paymentMethods": "Secure checkout · Shop Pay · Apple Pay · Visa · Mastercard · Amex",

  "footer.tagline": "Grow at your own pace. European-made Pikler climbing frames and Montessori furniture, shipped from our Finnish store to your door.",
  "footer.location": "Ships from Helsinki, Finland",
  "footer.vat": "· Duties & taxes may apply at delivery",
  "footer.withdrawal": "30-day returns",

  "ship.cartTagline": "Free US shipping · 6–10 business days",
  "ship.cartVatNote": "USD · taxes calculated at checkout",
  "ship.cartSecure": "Secure checkout",

  "products.subtitle": "European-made Pikler climbing frames, learning towers and Montessori furniture — free US shipping in 6–10 business days.",

  "footer.hoursHeader": "Free Montessori school",
  "footer.hoursTime": "Articles, age guides and safety tips for parents.",
  "footer.trust.promiseShipping": "Free US shipping · 6–10 business days",
  "footer.trust.promiseReturns": "30-day returns",
  "footer.trust.promiseFinnish": "Finnish store · European makers",
};

export const dictionaries = { fi, en, sv, et, "en-US": enUS } as const;